// extracted by mini-css-extract-plugin
export default {"FailControler":"JbMZ55IgAcudpqE6p8pG","failHeading":"Jza950ww3qy0oc0J207R","warning":"KTz7f75HFEMFTZsNu86j","button":"epAuubluqCA9Li2cypbt","address":"wjaKj4TCotNClr3rBb3T"};